import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BaseResolver } from '@principle-theorem/ng-shared';
import { Brand } from '@principle-theorem/principle-core';
import {
  IPrescriptionItem,
  type IBrand,
} from '@principle-theorem/principle-core/interfaces';
import {
  type CollectionReference,
  type WithRef,
} from '@principle-theorem/shared';

@Injectable()
export class BrandPrescriptionItemCollectionResolverService extends BaseResolver<
  CollectionReference<IPrescriptionItem>
> {
  static readonly resolverKey: string = 'prescriptionItemCollection';

  resolve(
    route: ActivatedRouteSnapshot
  ): CollectionReference<IPrescriptionItem> {
    const brand = this._findInheritedRouteData<WithRef<IBrand>>(route, 'brand');
    if (!brand) {
      throw new Error('No Brand found');
    }
    return Brand.prescriptionItemCol(brand);
  }
}
